<template>
  <button class="e-btn" :type="type" :disabled="disabled" @click="click" @mouseover="mouseover" :class="{'e-btn-primary': color === 'primary', 'e-button-icon': icon, 'e-disabled': disabled, 'i-btn-sm' : sm}">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'i-button',
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    rounded: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    },
    gradient: {
      type: Boolean,
      default: false
    },
    sm: {
      type: Boolean,
      default: false
    },
    md: {
      type: Boolean,
      default: false
    },
    lg: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'button'
    },
    icon: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click: function (e) { this.$emit('click', e) },
    mouseover: function (e) { this.$emit('mouseover', e) }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/components/button";
</style>



// WEBPACK FOOTER //
// src/components/ui/button.vue